import React, { useState } from 'react';
import styled from 'styled-components';
import { Box } from 'dma-ui-kit';

const Container = styled(Box)`
padding: 0 12px;
margin-bottom: 12px;
display: block;
text-align: center;

@media (min-width: 768px) {
    padding: 0 24px;
}

@media (min-width: 1024px) {
    padding: 0 48px;
}    
`;

const ImageContainer = styled(Box)`
    margin: auto;
    width: 100%;
`;

const ImagePrimary = styled.img`
    max-height: 400px;
    max-width: 400px;

    @media (min-width: 768px) {
        max-width: 450px;
    }

    @media (min-width: 1024px) {
        max-width: 100%;
    }    

`;

const ImageTile = styled.img`
    max-height: 100px;
    padding: 2px;
    cursor: pointer;
`;

const SlideShow = props => {
    const { data } = props.paragraph.relationships.field_media;
    const [primaryImage, setPrimaryImage] = useState(0);

    const showPrimaryImage = () => {
        return (
            <ImagePrimary src={data[primaryImage].relationships.field_media_image.data.attributes.uri.url} alt={data[primaryImage].attributes.name} />
        );
    };

    const showTiles = () => {
        const results = data.map((result, index) => {
            const { attributes, relationships } = result;

            return (
                <ImageTile key={index} src={relationships.field_media_image.data.attributes.uri.url} alt={attributes.name} onClick={() => setPrimaryImage(index)} />
            );
        });
        return results;
    };    
    
    return (
        <Container>
            <ImageContainer>{showPrimaryImage()}</ImageContainer>
            <ImageContainer>{showTiles()}</ImageContainer>
        </Container>
    );
};

export default SlideShow;